import React from 'react';
// import logo from './logo.svg';
// import './App.css';
import SideBar from "./components/sidebar"


function Model() {
  return (
    <div >
      <SideBar />
    </div>
  );
}

export default Model;
